import React, { useState, useEffect } from 'react';
import useStyles from './styles';

import { MembershipSetup } from "./Setup";
import { SetupPricing } from "./SetupPricing";
import { SetupStripe } from "./SetupStripe";

interface MembershipProps {
    step?: number;
    user?: any;
}
export const Membership = (props: MembershipProps) => {
    const classes = useStyles();
    const [step, setStep] = useState<number>(0);

    useEffect(() => {
        if (props?.step) {
            setStep(props?.step);
        }
    },[props?.step]);

    const renderStep = () => {
        if (step === 0) {
            return (<MembershipSetup setStep={setStep} user={props?.user} />);
        } else if (step === 1) {
            return (<SetupStripe setStep={setStep} />);
        } else if (step === 2) {
            return (<SetupPricing setStep={setStep} user={props?.user} />);
        }
        return null;
    };


    return (
        <div className={classes.container}>
            { renderStep() }
        </div>
    );
}